(function () {
  'use strict';

  /* ----------------------------------------------------------------
     Inject modal shell once
     ---------------------------------------------------------------- */
  var backdrop = document.createElement('div');
  backdrop.id = 'hoa-qv-backdrop';
  backdrop.className = 'hoa-qv-backdrop';
  backdrop.setAttribute('role', 'dialog');
  backdrop.setAttribute('aria-modal', 'true');
  backdrop.setAttribute('aria-label', 'Schnellansicht');
  backdrop.setAttribute('aria-hidden', 'true');
  backdrop.hidden = true;
  document.body.appendChild(backdrop);

  var previousFocus = null;

  function openBackdrop(html) {
    previousFocus = document.activeElement;
    backdrop.innerHTML = html;
    backdrop.removeAttribute('hidden');
    backdrop.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { backdrop.classList.add('hoa-qv--open'); });
    var closeBtn = backdrop.querySelector('.hoa-qv-close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 280);
    trapFocus();
    attachModalEvents();
  }

  function closeModal() {
    backdrop.classList.remove('hoa-qv--open');
    backdrop.setAttribute('aria-hidden', 'true');
    setTimeout(function () { backdrop.hidden = true; }, 260);
    if (previousFocus) previousFocus.focus();
  }

  /* ----------------------------------------------------------------
     Focus trap
     ---------------------------------------------------------------- */
  function trapFocus() {
    backdrop.addEventListener('keydown', handleKey);
  }

  function handleKey(e) {
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    var focusable = Array.from(backdrop.querySelectorAll(
      'button, [href], input, select, [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  }

  /* ----------------------------------------------------------------
     Modal interaction events
     ---------------------------------------------------------------- */
  function attachModalEvents() {
    /* Close on backdrop click */
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closeModal();
    }, { once: true });

    /* Close button */
    var closeBtn = backdrop.querySelector('.hoa-qv-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    /* Size selection */
    var sizeButtons = backdrop.querySelectorAll('.hoa-qv-size:not(.sold-out)');
    var selectedVariantId = null;
    var atcBtn = backdrop.querySelector('.hoa-qv-atc');
    var priceEl = backdrop.querySelector('.hoa-qv-price');

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selectedVariantId = btn.dataset.variantId;
        var price = btn.dataset.price;
        var comparePrice = btn.dataset.comparePrice;
        if (priceEl) {
          priceEl.innerHTML = comparePrice && comparePrice !== '0'
            ? '<s>' + comparePrice + '</s> ' + price
            : price;
        }
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.dataset.variantId = selectedVariantId;
        }
      });
    });

    /* Add to cart */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var varId = atcBtn.dataset.variantId;
        if (!varId) return;
        atcBtn.disabled = true;
        atcBtn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: parseInt(varId, 10), quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            atcBtn.textContent = '✓ Hinzugefügt';
            setTimeout(function () {
              closeModal();
              /* Trigger cart drawer open if it exists */
              var drawerTrigger = document.querySelector('[data-hoa-cart-open], .js-drawer-open-right');
              if (drawerTrigger) drawerTrigger.click();
            }, 700);
          })
          .catch(function () {
            atcBtn.disabled = false;
            atcBtn.textContent = 'In den Warenkorb';
          });
      });
    }
  }

  /* ----------------------------------------------------------------
     Load product data & render modal
     ---------------------------------------------------------------- */
  function loadProduct(handle) {
    /* Show loading state */
    openBackdrop(
      '<div class="hoa-qv-modal"><div class="hoa-qv-loading">Wird geladen…</div></div>'
    );

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (p) { renderModal(p); })
      .catch(function () {
        backdrop.querySelector('.hoa-qv-loading').textContent = 'Fehler beim Laden.';
      });
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function renderModal(product) {
    var img = product.featured_image
      ? product.featured_image.replace('_{width}x', '_600x')
      : '';

    /* Build variant buttons */
    var hasSizes = product.options && product.options.length > 0 && product.options[0] !== 'Title';
    var sizeHtml = '';
    if (hasSizes) {
      var sizeOption = product.options.indexOf('Size') !== -1 ? product.options.indexOf('Size')
                     : product.options.indexOf('Größe') !== -1 ? product.options.indexOf('Größe')
                     : 0;
      var labelName = product.options[sizeOption] || 'Größe';
      sizeHtml =
        '<div class="hoa-qv-options">' +
          '<p class="hoa-qv-option-label">' + labelName + '</p>' +
          '<div class="hoa-qv-sizes">';

      var firstAvailable = null;
      product.variants.forEach(function (v) {
        var soldOut = !v.available;
        var val = v.options ? v.options[sizeOption] : v.title;
        if (!soldOut && !firstAvailable) firstAvailable = v;
        sizeHtml +=
          '<button class="hoa-qv-size' + (soldOut ? ' sold-out' : '') + '"' +
            ' data-variant-id="' + v.id + '"' +
            ' data-price="' + formatMoney(v.price) + '"' +
            ' data-compare-price="' + (v.compare_at_price ? formatMoney(v.compare_at_price) : '0') + '"' +
            (soldOut ? ' disabled aria-disabled="true"' : '') +
          '>' + val + '</button>';
      });

      sizeHtml += '</div></div>';
    }

    /* Default price from first available variant */
    var defaultVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var priceHtml = defaultVariant.compare_at_price && defaultVariant.compare_at_price > defaultVariant.price
      ? '<s>' + formatMoney(defaultVariant.compare_at_price) + '</s> ' + formatMoney(defaultVariant.price)
      : formatMoney(defaultVariant.price);

    var html =
      '<div class="hoa-qv-modal">' +
        '<button class="hoa-qv-close" aria-label="Schließen" type="button">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="hoa-qv-img-wrap">' +
          (img ? '<img class="hoa-qv-img" src="' + img + '" alt="' + product.title.replace(/"/g, '&quot;') + '">' : '') +
        '</div>' +
        '<div class="hoa-qv-info">' +
          (product.vendor ? '<p class="hoa-qv-vendor">' + product.vendor + '</p>' : '') +
          '<h2 class="hoa-qv-title">' + product.title + '</h2>' +
          '<p class="hoa-qv-price">' + priceHtml + '</p>' +
          sizeHtml +
          '<button class="hoa-qv-atc"' +
            ' data-variant-id="' + (hasSizes ? '' : defaultVariant.id) + '"' +
            (defaultVariant.available ? '' : ' disabled') +
          '>In den Warenkorb</button>' +
          '<a class="hoa-qv-pdp-link" href="/products/' + product.handle + '">Vollständige Produktseite →</a>' +
        '</div>' +
      '</div>';

    backdrop.innerHTML = html;

    /* Auto-select first available size */
    if (hasSizes) {
      var firstBtn = backdrop.querySelector('.hoa-qv-size:not(.sold-out)');
      if (firstBtn) {
        firstBtn.classList.add('active');
        var atcBtn = backdrop.querySelector('.hoa-qv-atc');
        if (atcBtn) atcBtn.dataset.variantId = firstBtn.dataset.variantId;
      }
    }

    backdrop.setAttribute('aria-hidden', 'false');
    var closeBtn = backdrop.querySelector('.hoa-qv-close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    attachModalEvents();
  }

  /* ----------------------------------------------------------------
     Attach quick-view triggers to product cards
     ---------------------------------------------------------------- */
  function attachTriggers() {
    document.querySelectorAll('.hoa-qv-trigger').forEach(function (btn) {
      if (btn.dataset.qvAttached) return;
      btn.dataset.qvAttached = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.dataset.productHandle;
        if (handle) loadProduct(handle);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', attachTriggers);

  /* Re-attach if new cards are injected (e.g. "show more") */
  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(attachTriggers);
    document.addEventListener('DOMContentLoaded', function () {
      var grid = document.querySelector('.collection-grid, .hoa-featured-grid');
      if (grid) mo.observe(grid, { childList: true, subtree: true });
    });
  }
})();
